import { HiddenExcelProvider } from './context/HiddenExcelContext';
import { HiddenExcelLayout } from './components/HiddenExcelLayout';

export const HiddenExcel = () => {
    return (
        <HiddenExcelProvider>
            <HiddenExcelLayout />
        </HiddenExcelProvider>
    );
};
